import React from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import {
  CardContent,
  Grid,
  Card as MuiCard,
  LinearProgress,
} from "@mui/material";

import * as Enums from "src/utils/enums";
import useForm from "src/hooks/useForm";

import { getNextCode } from "src/services/generalService";
import { DefaultService } from "src/services/defaultService";

import AMIndexList from "src/pages/components/AMIndexList";

const Card = styled(MuiCard)(spacing);

function LookupPage({ menuItemCode }) {
  const defaultService = new DefaultService("Lookup");

  const getNextCodeFunc = async () => {
    const { data } = await getNextCode(menuItemCode, "code", "");
    return data || "";
  };

  const getByIdFunc = async (id) => {
    const { data } = await defaultService.get(menuItemCode, id);

    if (data) {
      delete data.id;
      delete data.ID;
      delete data.Id;
      delete data.iD;
    }

    return data;
  };

  const saveFormFunction = async (currentMenuItemCode, formData) => {
    const { data } = await defaultService.save(currentMenuItemCode, formData);
    return data;
  };

  const deleteFunction = async (currentMenuItemCode, formData) => {
    const { data } = await defaultService.delete(currentMenuItemCode, formData);
    return data;
  };

  const {
    state: values,
    indexColumns,
    renderFormHeader,
    renderFormInput,
    preLoaded,
  } = useForm({
    menuItemCode,
    nextCodeField: "code",
    getNextCodeFunc,
    getByIdFunc,
    saveFunction: saveFormFunction,
    deleteFunction,
  });

  if (!preLoaded) return <LinearProgress my={2} />;

  const mainData = (
    <Card mb={6}>
      <CardContent>
        <Grid container spacing={4}>
          {renderFormInput("code", "text", {
            style: { maxWidth: 100 },
          })}
          {renderFormInput("name_Ar")}
          {renderFormInput("name_En")}
          {renderFormInput("notes")}
          {renderFormInput("notActive", Enums.ControlType.CheckBox)}
        </Grid>
      </CardContent>
    </Card>
  );

  return (
    <React.Fragment>
      {renderFormHeader()}
      {!values.id && indexColumns && !!indexColumns.length && (
        <AMIndexList
          key={indexColumns.length}
          columns={indexColumns}
          getAll={defaultService.getAll}
        />
      )}
      {!!values.id && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            {mainData}
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
}

export default LookupPage;
